import { render, staticRenderFns } from "./Templates_Type.vue?vue&type=template&id=936c194e&scoped=true"
import script from "./Templates_Type.vue?vue&type=script&lang=js"
export * from "./Templates_Type.vue?vue&type=script&lang=js"
import style0 from "./Templates_Type.vue?vue&type=style&index=0&id=936c194e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "936c194e",
  null
  
)

export default component.exports